export enum RebateReleaseStatus {
  Pending,
  Released,
  Rejected
}
